
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { db, storage } from '@/firebase';
import { NODE_RUN_RESULT_SELECTION_MODE } from '@/views/Runnits/constants';
import RunnitDynamicFieldLabelRow from '@/views/Runnits/RunnitSettings/RunnitDynamicFieldLabelRow.vue';
import {
	RunnitMask,
	RunnitNodeRunInputValue,
	RunnitNodeRunResult,
	RunnitUpload,
	UploadFile,
	IMAGE_UPLOAD_MODE
} from '@run-diffusion/shared';
import VideoInputSelectedVideoContainer from '@/views/Runnits/RunnitSettings/VideoInput/VideoInputSelectedVideoContainer.vue';
import { IMAGE_GALLERY_DIALOG_NAV, ImageGalleryDialogNav } from '@/components/ImageGallery/utils';
import { RunnitDynamicFieldMixin } from '@/views/Runnits/RunnitSettings/mixins/RunnitDynamicFieldMixin';
import { RunnitsImageSelectMixin } from '@/mixins/RunnitsImageSelectMixin';
// import InpaintingEditor from '../InpaintingEditor/InpaintingEditor.vue';
import BigNumber from 'bignumber.js';

export default Vue.extend({
	name: 'VideoInput',
	mixins: [
		RunnitDynamicFieldMixin,
		RunnitsImageSelectMixin,
	],
	props: {
		field: { type: Object, required: true },
		value: { type: Object, default: null },
		nodeId: { type: String, default: null },
		adminOnly: { type: Boolean, default: false },
	},
	data () {


		return {
			IMAGE_UPLOAD_MODE,
			IMAGE_GALLERY_DIALOG_NAV,
			FILE_SIZE_LIMIT: 104857600, // 100 MB in bytes for videos

			isUploading: false,
			isBeingDraggedOver: false,

			videoDetails: null,
		};
	},
	destroyed () {
		this.exitSelectionMode(this.selectionStateTriggerId);
	},
	computed: {
		...mapState([
			'runnitState',
			'user',
		]),
		...mapGetters([
			// 'getInpaintingEditorState',
		]),
		selectionStateTriggerId () {
			return `video-input-${this.field.uuid}`;
		},
		// hasInpainting () {
		// 	return !!this._get(this.field, 'display.hasInpainting');
		// },
		// inpaintingRequired () {
		// 	return this.hasInpainting && this.field.required && !!this._get(this.field, 'display.inpaintingRequired');
		// },
		hasStrength () {
			return !!this._get(this.field, 'display.hasStrength');
		},
		videoValue () {
			let val = this.value
			if (/** this.hasInpainting || */this.hasStrength) {
				val = this._get(this.value, 'video') || null;
			}
			return val;
		},
		// inpaintingValue () {
		// 	if (this.hasInpainting) {
		// 		return this._get(this.value, 'inpainting') || { mask: null };
		// 	}
		// 	return null;
		// },
		strengthValue () {
			if (this.hasStrength) {
				return this._get(this.value, 'strength') || 0.8;
			}
			return null;
		},
		videoDuration () {
			// Get duration from either nodeRunResult or upload
			if (this.videoValue) {
				if (this._get(this.videoValue, 'nodeRunResult.file.duration')) {
					return this.videoValue.nodeRunResult.file.duration;
				}
				if (this._get(this.videoValue, 'upload.duration')) {
					return this.videoValue.upload.duration;
				}
			}
			return null;
		},
		selectionStateForTrigger () {
			return this.getSelectionStateByTrigger(this.selectionStateTriggerId);
		},
	},
	watch: {
		// value: {
		// 	immediate: true,
		// 	async handler (newVal: RunnitNodeRunInputValue, oldVal: RunnitNodeRunInputValue) {
		// 		if (this.hasInpainting) {
		// 			const mask = this._get(newVal, 'inpainting.mask') || {}
		// 			await this.setMaskURL(this._get(mask, 'id') || null);
		// 		} else {
		// 			this.setMaskURL(null);
		// 		}
		// 	},
		// },
		selectionStateForTrigger: {
			immediate: false,
			handler (newVal, oldVal) {
				this.commitSingleSelectionStateValue(
					newVal,
					oldVal,
					this.field.uuid,
					this._get(this.videoValue, 'nodeRunResult.uuid') || null,
					this._get(this.videoValue, 'upload.id') || null,
					() => this.onInput(null, /** null, */null),
					(value) => this.onInput(value, /** this.inpaintingValue, */ this.strengthValue),
				);
			},
		},
	},
	methods: {
		...mapActions([
			'updateRunnitState',
			// 'updateInpaintingEditorState',
			'updateSnackbar',
		]),
		onInput (video: RunnitNodeRunInputValue, /** inpainting: RunnitNodeRunInputValue, */strength: number) {
			if (/** this.hasInpainting || */this.hasStrength) {
				if (video || /** inpainting || */strength) {
					this.$emit('input', {
						video,
						/** inpainting, */
						strength,
					});
				} else {
					this.$emit('input', null);
				}
			} else {
				this.$emit('input', video);
			}
		},
		clearValueAndStartSelectSelectionMode () {
			this.onInput(null, null, null);
			this.clearSelectionsFromState(this.selectionStateTriggerId);
			this.enterSelectionMode(NODE_RUN_RESULT_SELECTION_MODE.SINGLE, this.selectionStateTriggerId, this.field, ['VID']);
		},
		onStrengthChange (strength) {
			this.onInput(this.videoValue, /** this.inpaintingValue, */ strength);
		},
		startLibrarySelectionMode (imageGalleryDialogInitialNav: ImageGalleryDialogNav) {
			this.updateRunnitState({
				imageGalleryDialogOpen: true,
				imageGalleryDialogInitialNav: imageGalleryDialogInitialNav,
			});
			this.enterSelectionMode(NODE_RUN_RESULT_SELECTION_MODE.SINGLE, this.selectionStateTriggerId, this.field, ['VID']);
		},
		onToggleVideoSelectionMode () {
			if (this.currentSelectionState.triggeringId) {
				this.exitSelectionMode(this.currentSelectionState.triggeringId);
			} else {
				this.enterSelectionMode(NODE_RUN_RESULT_SELECTION_MODE.SINGLE, this.selectionStateTriggerId, this.field, ['VID']);
			}
		},
		// async onInpaintingMaskChange (mask) {
		// 	this.onInput(this.videoValue, { ...this.inpaintingValue, mask }, this.strengthValue);
		// 	await this.setMaskURL(this._get(mask, 'id') || null);
		// },
		// async setMaskURL (maskId) {
		// 	if (maskId) {
		// 		const maskRef = db.doc(`runnitMasks/${maskId}`);
		// 		const mask: RunnitMask = (await maskRef.get()).data() as RunnitMask;

		// 		const maskImageRef = storage.ref(`runnitMasks/users/${mask.userId}/masks/${mask.name}`);

		// 		let maskURL = null;
		// 		try {
		// 			// Exists
		// 			maskURL = await maskImageRef.getDownloadURL();
		// 		} catch (err) {
		// 			// doesn't exist
		// 		}
		// 		this.updateInpaintingEditorState({
		// 			fieldUuid: this.field.uuid,
		// 			editorState: {
		// 				maskUrl: maskURL,
		// 			},
		// 		});
		// 	} else {
		// 		this.updateInpaintingEditorState({
		// 			fieldUuid: this.field.uuid,
		// 			editorState: {
		// 				maskUrl: null,
		// 			},
		// 		});
		// 	}
		// },
		validateVideoAspectRatio (v: RunnitNodeRunInputValue) {
			if (!v) return true; // no value so can't check its ratio
			const videoDetails: {
				width: number,
				height: number,
			} = v.nodeRunResult ? {
				width: v.nodeRunResult.file.width,
				height: v.nodeRunResult.file.height,
			} : v.upload ? {
				width: v.upload.width,
				height: v.upload.height,
			} : null;
			if (!videoDetails) return true; // we don't have any information on the video yet

			let { maxAspectRatio } = this.field.display || {};
			maxAspectRatio = maxAspectRatio || 3;

			const aspectRatio: BigNumber = new BigNumber(videoDetails.width).div(videoDetails.height);

			if (aspectRatio.isGreaterThan(maxAspectRatio)) {
				return `Video aspect ratio (${aspectRatio.toFixed(2)}:1) is too wide. Maximum allowed is ${maxAspectRatio}:1`;
			}
			if (aspectRatio.isLessThan(new BigNumber(maxAspectRatio).pow(-1))) {
				return `Video aspect ratio (1:${aspectRatio.pow(-1).toFixed(2)}) is too tall. Maximum allowed is 1:${maxAspectRatio}`;
			}

			return true;
		},
		validateVideoMinDimension (v: RunnitNodeRunInputValue) {
			if (!v) return true; // no value so can't check its dimensions
			const videoDetails: {
				width: number,
				height: number,
			} = v.nodeRunResult ? {
				width: v.nodeRunResult.file.width,
				height: v.nodeRunResult.file.height,
			} : v.upload ? {
				width: v.upload.width,
				height: v.upload.height,
			} : null;
			if (!videoDetails) return true; // we don't have any information on the video yet

			const { minDimension } = this.field.display || {};
			if (!minDimension) return true; // no minimum dimension requirement

			if (videoDetails.width < minDimension) {
				return `Video width (${videoDetails.width}px) is too small. Minimum required is ${minDimension}px`;
			}
			if (videoDetails.height < minDimension) {
				return `Video height (${videoDetails.height}px) is too small. Minimum required is ${minDimension}px`;
			}

			return true;
		},
		validateVideoMaxWidth (v: RunnitNodeRunInputValue) {
			if (!v) return true; // no value so can't check its width
			const videoDetails: {
				width: number,
			} = v.nodeRunResult ? {
				width: v.nodeRunResult.file.width,
			} : v.upload ? {
				width: v.upload.width,
			} : null;
			if (!videoDetails || !videoDetails.width) return true; // we don't have any information on the video yet

			const { maxWidth } = this.field.display || {};
			if (!maxWidth) return true; // no maximum width requirement

			if (videoDetails.width > maxWidth) {
				return `Video width (${videoDetails.width}px) exceeds maximum allowed width of ${maxWidth}px`;
			}

			return true;
		},
		validateVideoMaxHeight (v: RunnitNodeRunInputValue) {
			if (!v) return true; // no value so can't check its height
			const videoDetails: {
				height: number,
			} = v.nodeRunResult ? {
				height: v.nodeRunResult.file.height,
			} : v.upload ? {
				height: v.upload.height,
			} : null;
			if (!videoDetails || !videoDetails.height) return true; // we don't have any information on the video yet

			const { maxHeight } = this.field.display || {};
			if (!maxHeight) return true; // no maximum height requirement

			if (videoDetails.height > maxHeight) {
				return `Video height (${videoDetails.height}px) exceeds maximum allowed height of ${maxHeight}px`;
			}

			return true;
		},
		validateVideoMaxDuration (v: RunnitNodeRunInputValue) {
			if (!v) return true; // no value so can't check its duration
			const videoDetails: {
				duration: number,
			} = v.nodeRunResult ? {
				duration: v.nodeRunResult.file.duration,
			} : v.upload ? {
				duration: v.upload.duration,
			} : null;
			if (!videoDetails || !videoDetails.duration) return true; // we don't have any information on the video yet

			const { maxDuration } = this.field.display || {};
			if (!maxDuration) return true; // no maximum duration requirement

			if (videoDetails.duration > maxDuration) {
				return `Video duration (${videoDetails.duration}s) exceeds maximum allowed duration of ${maxDuration}s`;
			}

			return true;
		},
		handleVideoUpload (upload: any) {
			// Handle different types of uploads
			if (upload.nodeRunResult) {
				this.onInput({ nodeRunResult: upload.nodeRunResult }, /** this.inpaintingValue, */ this.strengthValue);
			} else if (upload.upload) {
				this.onInput({ upload: upload.upload }, /** this.inpaintingValue, */ this.strengthValue);
			} else {
				this.onInput({ upload }, /** this.inpaintingValue, */ this.strengthValue);
			}
		},
	},
	components: {
		VideoInputSelectedVideoContainer,
		RunnitDynamicFieldLabelRow,
		// InpaintingEditor,
	},
});
